import { yup } from '@guiker/shared-framework'

export const readAllPayoutsSchema = yup.object({
  payoutMethodIds: yup.array(yup.string()).nullable().default([]),
})
